/**
 * @function
 * @description Handles and track custom error using ContentSquare
 * @param {string} message Error message
 * @param {string} type Error type
 * @param {string} severity Error severity
 * @param {string} lang Error language
 */
exports.handleCustomError = (message, type, severity, lang) => {
    if (!message) {
        return;
    }

    window._uxa = window._uxa || [];
    const options = {};

    if (type) {
        options.type = type;
    }

    if (severity) {
        options.severity = severity;
    }

    if (lang) {
        options.lang = lang;
    }

    window._uxa.push(['trackError', message, options]);
};

/**
 * @function
 * @description Pushing user indetifier to the ContentSquare layer
 * @param {string} email Customer email
 */
exports.pushUserIdentifier = email => {
    if (!email) {
        return;
    }

    window._uxa = window._uxa || [];
    window._uxa.push(['trackPageEvent', `@user-identifier@${email.trim()}`]);
};
